module.exports = function() {
  return new Worker(__webpack_public_path__ + "cef5c1212c6f85bad4b0.worker.js");
};